import { Page } from "./util";

const NotFound = () => {
	return (
		<Page className="err404">
			<div className="container w100 flex-jc-cr flex-ai-cr flex-gap20 flex-column">
				<h1 className="error">404</h1>
				<h2>Not&nbsp;Found</h2>
				<p>There doesn't seem to be a clear path to where you want to go...</p>
			</div>
		</Page>
	);
}
 
export default NotFound;